import { Outlet } from "react-router";
import Nav from "./Nav";
import SideMenu from "./SideMenu";

const DefaultContainer = () => {
    return (
        <>
            <Nav />
            <SideMenu />
            <Outlet />
        </>
    )
}

export default DefaultContainer;